import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addFishAnimationToSprite, getFishFrameName } from '../AnimationManager';

export default class AnimatedFish extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,creaturetype, typeid, offsets) {
    super(scene);

    this.typeID = null;
    this.offsets = null;

    this.eyes = null;
    this.tail = null;

    this.isSwimming = false;
    this.tailDirection = null;
    this.tailAnimationListener = null;

    this.blinkWaiter = null;
    this.tailWaiter = null;

    this.stopOutline = null;

    // eslint-disable-next-line no-param-reassign
    if (!creaturetype) creaturetype = 'Fish';
    this.creatureType = creaturetype;
    this.typeID = typeid;
    this.offsets = offsets;
    this.blinkWaiter = Phaser.Math.Between(2,4);

    this.bodyAnimation = `${this.creatureType}_${this.typeID}_Body`;
    this.eyesAnimation = `${this.creatureType}_Round_Eye_Idle`;
    this.tailAnimation = `${this.creatureType}_${this.typeID}_Tail_Swim1`;

    const bodyName = getFishFrameName(this.bodyAnimation);
    this.bodySprite = this.scene.add.sprite(this.offsets.body.x, this.offsets.body.y, ABCyaPhaser.Images.DEFAULT_ATLAS, bodyName);

    const eyesName = getFishFrameName(this.eyesAnimation);
    this.eyes = this.scene.add.sprite(this.offsets.eyes.x, this.offsets.eyes.y, ABCyaPhaser.Images.DEFAULT_ATLAS, eyesName);
    this.eyes.scale = this.offsets.scale;

    const tailName = getFishFrameName(this.tailAnimation);
    this.tail = this.scene.add.sprite(0, this.offsets.tail.y, ABCyaPhaser.Images.DEFAULT_ATLAS, tailName);

    this.setupAnimations();
    addFishAnimationToSprite(this.eyes, 'Fish_Round_Eye_Blink', false);

    this.add([this.tail, this.bodySprite, this.eyes]);
  }

  setupAnimations() {
    addFishAnimationToSprite(this.bodySprite, this.bodyAnimation);
    addFishAnimationToSprite(this.eyes, this.eyesAnimation);
    addFishAnimationToSprite(this.tail, this.tailAnimation);
  }

  switchFish (fishID, offsets) {
    this.typeID = fishID;

    this.bodyAnimation = `${this.creatureType}_${this.typeID}_Body`;
    this.eyesAnimation = `${this.creatureType}_Round_Eye_Idle`;
    this.tailAnimation = `${this.creatureType}_${this.typeID}_Tail_Swim1`;

    this.offsets = offsets;
    const bodyName = getFishFrameName(this.bodyAnimation);
    this.bodySprite.setFrame(bodyName);
    this.bodySprite.x = this.offsets.body.x;
    this.bodySprite.y = this.offsets.body.y;

    const eyesName = getFishFrameName(this.eyesAnimation);
    this.eyes.setFrame(eyesName);
    this.eyes.x = this.offsets.eyes.x;
    this.eyes.y = this.offsets.eyes.y;
    this.eyes.scale = this.offsets.scale;

    const tailName = getFishFrameName(this.tailAnimation);
    this.tail.setFrame(tailName);
    this.tail.y = this.offsets.tail.y;
    this.tail.setVisible(true);

    this.setupAnimations();
  }

  startSwimming () {
    this.isSwimming = true;

    this.tailSwim();
  }

  tailSwim () {
    this.tailDirection = 1;
    this.tail.play(this.tailAnimation);
  }

  highlight () {
    const bodyName = getFishFrameName(`${this.creatureType}_${this.typeID}_Body_Outline`);
    this.bodySprite.setFrame(bodyName);
    this.bodySprite.x = this.offsets.body_outline.x;
    this.bodySprite.y = this.offsets.body_outline.y;
    this.tail.setVisible(false);
  };

  unhighlight () {
    const bodyName = getFishFrameName(`${this.creatureType}_${this.typeID}_Body`);
    this.bodySprite.setFrame(bodyName);
    this.bodySprite.x = this.offsets.body.x;
    this.bodySprite.y = this.offsets.body.y;
    this.tail.setVisible(true);
  }

  tick (delta) {
    if (this.blinkWaiter < 0) {
      this.eyes.play('Fish_Round_Eye_Blink');
      this.blinkWaiter = Phaser.Math.Between(2, 40);
    }
    else {
      this.blinkWaiter -= delta;
    }
  }
}